export default __webpack_public_path__ + "static/media/ios-pwa-guide-eye.54d2a8d9.png";